import { FloatingToolbar, FontSemiBold, Row } from '@rematter/ui-web';

import { useTranslations } from '@/finance/i18n/useTranslations';

type FinancialAccountListFloatingToolbarProps = {
  selectedRowsCount: number;
};

//
// ⚛️ ⚛️ ⚛️ FINANCIAL ACCOUNT LIST FLOATING TOOLBAR ⚛️ ⚛️ ⚛️
//
export const FinancialAccountListFloatingToolbar = ({
  selectedRowsCount,
}: FinancialAccountListFloatingToolbarProps) => {
  const t = useTranslations();

  return (
    <FloatingToolbar
      visible={selectedRowsCount > 0}
      className="@FinancialAccountListFloatingToolbar"
    >
      <Row gap2 yCenter>
        <Row
          yCenter
          xEnd
          className="min-w-[150px] gap-1.5 px-3 text-sm text-neutral/80"
        >
          <FontSemiBold>{selectedRowsCount}</FontSemiBold>
          {selectedRowsCount === 1
            ? t.financialAccounts.list.selection.singular
            : t.financialAccounts.list.selection.plural}
        </Row>
      </Row>
    </FloatingToolbar>
  );
};
